"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
console.log('%c /init/init-account.component.ts CONSTRUCTOR', 'color:white;background-color:gray;');
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const material_1 = require("@angular/material");
const forms_1 = require("@angular/forms");
const operators_1 = require("rxjs/operators");
const BaseComponent_1 = require("../commons/BaseComponent");
const app_service_1 = require("../commons/app.service");
const application_events_service_1 = require("../xs/services/events/application-events.service");
class InitAccountComponent extends BaseComponent_1.BaseComponent {
    constructor(service, route, router, snackBar, dialog, applicationEvents) {
        super(router, snackBar, dialog);
        this.service = service;
        this.route = route;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.passControl = new forms_1.FormControl('', [forms_1.Validators.required, forms_1.Validators.minLength(5)]);
        this.emailControl = new forms_1.FormControl('', [forms_1.Validators.required, forms_1.Validators.email]);
        this.nameControl = new forms_1.FormControl('', [forms_1.Validators.required]);
        this.accNameControl = new forms_1.FormControl('', [forms_1.Validators.required]);
        console.log('%c /init/init-account.component.ts', 'color:white;background-color:black;');
    }
    ngOnInit() {
        console.log('%c /init/init-account.component.ts : onInit()', 'color:white;background-color:black;');
        this.route.queryParams.subscribe(params => {
            //console.log("ENETR initComponent params: ",params)
            this.status = params["status"];
            this.message = params["msg"];
        });
    }
    createUserAccount() {
        console.log('%c /init/init-account.component.ts : createUserAccount()', 'color:white;background-color:black;');
        let args = {
            name: this.nameControl.value,
            email: this.emailControl.value,
            password: this.passControl.value,
            accountName: this.accNameControl.value,
        };
        this.loading = true;
        this.service.V.api('/access/registerCAN', 'post', args)
            .pipe(operators_1.flatMap(res => this.service.V.loginWithUsernameObservable(args.email, args.password)), operators_1.flatMap(res => this.service.refreshMe()), operators_1.flatMap(res => this.service.refreshData())).subscribe(res => {
            this.router.navigate(['app'], { queryParams: { setup: true } });
            this.loading = false;
        }, err => {
            this.loading = false;
            this.openSnackBarError(err.message);
        });
    }
}
exports.InitAccountComponent = InitAccountComponent;
